webpackJsonp([107859322201255],{

/***/ 1122:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0005_reputable_newsman.jpg","type":"Unit","subtype":"Mercenary","cost":2,"ATK":0,"HP":3,"rules_text_1":"Arrives: Choose a number. Opponents can't play spells or upgrades that cost that amount.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Reputable Newsman","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Blue","spec":null,"bottom":"Tech 0","rulings":[{"ruling":"When Newsman leaves play, his effect ends.","date":"2016-03-01T08:00:00.000Z","author":"Sirlin"}],"keywords":[],"slug":"reputable_newsman"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"reputable_newsman","keywords":[],"imageRegex":"/reputable_newsman.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-reputable-newsman-13d869bd9257baa4e0cf.js